
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FEEEC2","d":"M14.5 36.22a13 13 0 014.76-17.76l10.32-5.96a13 13 0 0117.76 4.76l9.03 15.65a13 13 0 01-4.75 17.75l-10.33 5.96a13 13 0 01-17.76-4.75L14.5 36.22z"}}),_c('path',{attrs:{"fill":"#FFCA2D","fill-rule":"evenodd","d":"M38 22a13 13 0 00-13 13v18.07a13 13 0 0013 13h3.05l2.32 2.45a5 5 0 007.26 0l2.32-2.45H56a13 13 0 0013-13V35a13 13 0 00-13-13H38z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#FEEEC2","d":"M44.74 35.61a2 2 0 013.63 0l1.21 2.6a2 2 0 001.58 1.15l2.85.35a2 2 0 011.12 3.45l-2.1 1.95a2 2 0 00-.6 1.85l.55 2.82a2 2 0 01-2.94 2.13l-2.5-1.4a2 2 0 00-1.95 0l-2.51 1.4a2 2 0 01-2.94-2.13l.55-2.82a2 2 0 00-.6-1.85L38 43.16a2 2 0 011.12-3.45l2.85-.35a2 2 0 001.57-1.14l1.21-2.6z"}})])
          )
        }
      }
    